import { BCMSRecord, DisabledPrompt, Link, useBCMSContext, useParams, useRoute } from "@bcm-dev/bcms-vite";
import MainContentContainer, { MainContentHeader, MainContentSection } from "components/shared/containers/MainContentContainer";
import { TravelPlan, Trip } from "model";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";
/**
 * @function ManageTravelPlansPage
 * @return {React.Component}
 * @exported true
 * @description The main component for ManageTravelPlansPage
 */

export default function ManageTravelPlansPage(props) {
  const globalController = useBCMSContext();
  const navigate = useRoute();
  const cardID = useParams().cardID ?? "0";

  BCMSRecord.globalControllerFor([ TravelPlan ,Trip], globalController);

  // Initalize all travel plans and filter by card, then create destination items for each
  const destinations = TravelPlan.initAll()
    .filter(item => item.card.id === cardID, [])
    .map(item => <DestinationItem key={ `Plan_${ item.id }` } plan={ item } /> ,[]);

  const addPlanLink = (
    <Link to={ `/home/securitytoken/receivetoken/${ cardID }/addtravelplan` }>
      <div className="flex-container flex-horizontal align-center-container bottom-border add-travel-plan-container clickable">
        <div className="flex-width">
          <span>Add Travel Plan</span>
        </div>
        <div className="set-width">
          <SVGAsset id="CirclePlusIcon" data-point="Add_Travel_Point"/>
        </div>
      </div>
    </Link> );

  return (
    <MainContentContainer className="manage-travel-plans-page" header={
      <MainContentHeader text="Manage Travel Plans" onClick={ evt => navigate(`/home/recenttransactions/${ cardID }`) } />
    }>
      <p>Add countries and U.S. states you may visit so we can help keep your card secure.</p>
      <MainContentSection text="Travel Plans" >
        { destinations }

        { destinations.length < 2 && addPlanLink }
        { destinations.length >= 2 && <DisabledPrompt>{ addPlanLink }</DisabledPrompt> }

        <div className="flex-container flex-horizontal info-container">
          <div className="set-width left-icon-container">
            <SVGAsset id="InformationIcon" />
          </div>
          <div className="flex-width">
            <span className="sub-text">You can add up to 2 Travel plans per card and within each Travel Plan max 15 destinations.</span>
          </div>
        </div>
      </MainContentSection>
    </MainContentContainer>
  );
}

/**
 * @function DestinationItem
 * @param {TravelPlan} plan - The travel plan to create the item from
 * @returns {React.Component}
 * @description Function to create the destination item
 * @exported false
 */
function DestinationItem(props) {
  const plan = props.plan ?? TravelPlan.firstInstanceOf();
  const trip = Trip.initByID(plan.trip);

  const numOfDestinations = trip.destinationName.split(",").length;
  const countries = trip.destinationName;
  const dateRange = `${ plan.departDate.format("M-d") } - ${ plan.returnDate.format("M-d") }`;

  const navigate = useRoute();
  const cardID = useParams().cardID ?? "0";

  const route = evt => navigate(`/home/travelplan/${ cardID }/${ plan.id }`);

  return (
    <div className="flex-container flex-horizontal align-center-container bottom-border destination-container">
      <div className="flex-container flex-horizontal align-center-container flex-width clickable" onClick={ route }>
        <div className="flex-width">
          <p><span data-point="Number_OF_Destinations">{numOfDestinations} Destination{ numOfDestinations > 1 ? "s" : "" }</span></p>
          <p><span className="sub-text">{ countries }</span></p>
        </div>
        <div className="set-width">
          <p><span data-point="Date_Range_Travel_Plans">{dateRange}</span></p>
        </div>
        <div className="set-width">
          <SVGAsset id="RightChevronIcon" className="chevron-icon right-inline-icon" />
        </div>
      </div>

      <div className="set-width">
        <DisabledPrompt>
          <SVGAsset id="VerticalDotsIcon" className="chevron-icon right-inline-icon clickable" />
        </DisabledPrompt>
      </div>
    </div>
  );
}